export default "__VITE_ASSET__BO0Zh6v___"